import src from "IMAGE";
export default { src, width: 120, height: 96, blurWidth: 0, blurHeight: 0};
